// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requestRmaButtonsStyles } from "@steiner/Overrides/Widgets/RequestRma/RequestRmaButtons";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

requestRmaButtonsStyles.sendButton = {
    variant: "primary",
    css: css`
        width: auto;
        padding: 0 16px;
    `,
};

requestRmaButtonsStyles.cancelButton = {
    variant: "secondary",
    css: css`
        width: auto;
    `,
};

requestRmaButtonsStyles.buttonsContainer = {
    css: css`
        margin-top: 12px;
        display: flex;
        gap: 12px;
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            flex-direction: column-reverse;
        }
    `,
};
